import AvatarAppleGrey from "../../../assets/images/default-avatar/default-apple-grey.svg";
import AvatarApple from "../../../assets/images/default-avatar/default-apple.svg";
import AvatarAvocadoGrey from "../../../assets/images/default-avatar/default-avocado-grey.svg";
import AvatarAvocado from "../../../assets/images/default-avatar/default-avocado.svg";
import AvatarBananaGrey from "../../../assets/images/default-avatar/default-banana-grey.svg";
import AvatarBanana from "../../../assets/images/default-avatar/default-banana.svg";
import AvatarLemonGrey from "../../../assets/images/default-avatar/default-lemon-grey.svg";
import AvatarLemon from "../../../assets/images/default-avatar/default-lemon.svg";
import AvatarPearGrey from "../../../assets/images/default-avatar/default-pear-grey.svg";
import AvatarPear from "../../../assets/images/default-avatar/default-pear.svg";
import AvatarPineappleGrey from "../../../assets/images/default-avatar/default-pineapple-grey.svg";
import AvatarPineapple from "../../../assets/images/default-avatar/default-pineapple.svg";
import {
  DEFAULT_PROFILE_PICTURES,
  DefaultProfilePicture,
} from "../../../../../api/src/shared/domain/user";
import type { ProfilePictureUser } from "../../../components/ProfilePicture";

export const defaultAvatarImages = {
  [DefaultProfilePicture.Pear]: {
    default: AvatarPear,
    disabled: AvatarPearGrey,
  },
  [DefaultProfilePicture.Apple]: {
    default: AvatarApple,
    disabled: AvatarAppleGrey,
  },
  [DefaultProfilePicture.Pineapple]: {
    default: AvatarPineapple,
    disabled: AvatarPineappleGrey,
  },
  [DefaultProfilePicture.Lemon]: {
    default: AvatarLemon,
    disabled: AvatarLemonGrey,
  },
  [DefaultProfilePicture.Banana]: {
    default: AvatarBanana,
    disabled: AvatarBananaGrey,
  },
  [DefaultProfilePicture.Avocado]: {
    default: AvatarAvocado,
    disabled: AvatarAvocadoGrey,
  },
};

export function pickUserImage(user: ProfilePictureUser) {
  if (user.profilePicture && user.profilePicture.name) {
    return defaultAvatarImages[user.profilePicture.name].default;
  }

  // Select a picture based on the user's name length
  const index = (user.fullname?.length ?? 0) % DEFAULT_PROFILE_PICTURES.length;
  const randomImage =
    DEFAULT_PROFILE_PICTURES[index] ?? DEFAULT_PROFILE_PICTURES.at(0);

  return defaultAvatarImages[randomImage].default;
}
